import React from "react";

export const Testimonials = (props) => {
  return (
    <div id="testimonials" className="testimonials-section">
      <div className="container">
        <div className="section-title text-center">
          <h2>What our clients say</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <div className="testimonial text-center">
                    <div className="testimonial-content">
                      <p>"{d.text}"</p>
                      <div className="testimonial-meta text-center">- {d.name}</div>
                      <div className="testimonial-meta text-center">{d.title}</div>
                    </div>
                  </div>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
